import {mapMutations, mapActions, mapGetters} from "vuex";

export default {
    name: "main-footer",
    props: {
        item: {
            type: Object,
default: () => ({ phones: [], emails: [], instagram: '', facebook: '', address: '', map_link: '' })
        },
        menu: {
            type: Array,
            default: () => []
        }
        ,
    },
    computed: {
        currentYear(){
            let date =  new Date().getFullYear();
            return date
        },
        ...mapGetters({})
    },
    methods: {
        ...mapMutations({
            // changeLoginPopup:'popups/CHANGE_LOGIN_POPUP'
        }),
        ...mapActions({})
    }, created() {

    }
}
